// src
import back from "services/plannings";
import * as sync from "./index";

export const fetchSearch = (query) => async (dispatch, getState) => {
  await back.request(
    `/search/${query}`,
    dispatch,
    getState,
    () => dispatch(sync.searchRequest(query)),
    (json) => dispatch(sync.searchSuccess(json)),
    () => dispatch(sync.searchFailure()),
  );
};
